<template>
  <div class="container">
  <ol class="breadcrumb">
    <li><router-link :to="{ name: 'dashboard' }">Dashboard</router-link></li>
    <li class="active">Licenses</li>
  </ol>

  <div class="row">
    <div class="col-sm-6">
      <date-range-picker @daterange-change="dateRangeChange"></date-range-picker>
    </div>
    <div class="col-sm-6">
      <h5>{{ dateRangeFormat(dateStart) }} - {{ dateRangeFormat(dateEnd) }}</h5>
    </div>
  </div>

  <p>Showing {{ licenseCount }} licenses</p>
  <!-- {{ licenses }} -->
  <!-- {{ serialDetails }} -->

  <div v-for="lic in sortedLicenses" class="panel panel-default">
    <div class="panel-heading">
      {{ lic.license.key }}
    </div>
    <span>Issued - {{ formatDate(lic.license.issued) }}</span>
    <span>{{ lic.license.numActivations }} / {{ lic.license.maxInstances }} activations</span>

    <!-- <h5>Services</h5> -->
    <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th v-for="(service, name) in lic.attributes.license.service">
            {{ name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
        <td v-for="service in lic.attributes.license.service">
          <span v-if="service.enabled === 'true'" class="glyphicon glyphicon-ok" aria-hidden="true"></span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

    <!-- <h5>Activations</h5> -->
    <div v-if="lic.activations.length > 0">
    <table class="table">
      <thead>
        <th>Activation Date</th>
        <th>Serial</th>
        <th>Customer</th>
        <th>Expiry Date</th>
        <th>Expires In</th>
        <th>Installed</th>
        <th>Info</th>
      </thead>
      <tbody>
        <tr v-for="activation in lic.activations" v-bind:class="expiresRowClass(activation.activateTime, lic.attributes.license.root.expires, lic.attributes.license.root.duration)">
          <td>{{ formatDate(activation.activateTime) }}</td>
          <td>
            <router-link :to="{ name: 'serial', params: { id: activation.serial }}">{{ trim(activation.serial, 8) }}</router-link>
          </td>
          <td>{{ serialDetails[activation.serial] ? serialDetails[activation.serial].customer : '' }}</td>
          <td>{{ licenseExpiryDate(activation.activateTime, lic.attributes.license.root.expires, lic.attributes.license.root.duration).format('YYYY-MM-DD HH:mm') }}</td>
          <td>{{ licenseExpiryDate(activation.activateTime, lic.attributes.license.root.expires, lic.attributes.license.root.duration).fromNow() }}</td>
          <td>
            {{ activation.installed === 1 ? 'yes' : 'no' }}</td>
          <td>{{ activation.installInfo }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div v-else>
    <span>No license activations.</span>
  </div>
  </div>
</div>
</template>

<style scoped>
span {
  padding: 1em;
}
h5 {
  margin-left: 1em;
}
</style>

<script>
import _ from 'underscore'
import moment from 'moment'
import * as mutationTypes from '../store/mutation-types'
import licenseLib from '../lib/license'
import DateRangePicker from './DateRangePicker'
import C from '../constants'

export default {
  components: {
    DateRangePicker
  },

  data () {
    return {
      licenses: [],
      serials: []
    }
  },

  computed: {
    dateRange: {
      get () {
        return this.$store.state.filterDateRange.dateRange
      },

      set (value) {
        this.$store.commit(mutationTypes.FILTER_DATE_RANGE, value)
      }
    },
    dateStart () {
      return moment(this.dateRange[0], C.M_FMT_MS).utc()
    },

    dateEnd () {
      return moment(this.dateRange[1], C.M_FMT_MS).utc()
    },
    epochStart () {
      return this.dateRange[0]
    },
    epochEnd () {
      return this.dateRange[1]
    },
    sortedLicenses () {
      return _.sortBy(this.licenses, (item) => {
        return item.license.issued
      }).reverse()
    },
    licenseCount () {
      return this.sortedLicenses.length
    },
    serialDetails () {
      return _.mapObject(this.serials, (item) => {
        return {
          customer: item.details.length > 0 ? item.details[0].customer : ''
        }
      })
    }
  },

  methods: {
    fetch () {
      this.$store.commit(mutationTypes.LOADER_LOADING)
      Promise.all([
        this.$apiWsoc.fetchLicenses(null, this.epochStart, this.epochEnd),
        this.$apiWsoc.fetchDetails(null, this.epochStart, this.epochEnd)
      ])
      .then(([licenseResult, detailsResult]) => {
        this.$store.commit(mutationTypes.LOADER_NOT_LOADING)
        this.licenses = licenseResult.result
        this.serials = detailsResult
      })
      .catch((error) => {
        this.$store.commit(mutationTypes.LOADER_NOT_LOADING)
        console.log('error fetching', error)
      })
    },
    licenseExpiryDate (activationDate, expiryDate, duration) {
      return licenseLib.licenseExpiryDate(activationDate, expiryDate, duration)
    },
    expiresRowClass (activationDate, expiryDate, duration) {
      var licenseExpiryDate = licenseLib.licenseExpiryDate(activationDate, expiryDate, duration)
      var expiryDays = licenseExpiryDate.diff(moment(), 'days')
      if (expiryDays < 0) { return 'danger' }
      if (expiryDays < licenseLib.WARN_DAYS) { return 'warning' }
      return ''
    },
    trim (str, length) {
      return str.substring(0, length)
    },
    formatDate (date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    },
    dateRangeFormat (date) {
      return moment(date).format(C.M_FMT_READABLE_WEEKDAY)
    },
    dateRangeChange (e) {
      this.dateRange = e
    }
  },

  mounted () {
    this.fetch()
  },

  watch: {
    dateRange: function () {
      this.fetch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// License.vue?4bf87bb7